import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}],["path",{"d":"M9 9l6 6","key":"svg-1"}],["path",{"d":"M15 9h-6v6","key":"svg-2"}]]

const IconCircleArrowUpLeft = createReactComponent('outline', 'circle-arrow-up-left', 'CircleArrowUpLeft', __iconNode);

export default IconCircleArrowUpLeft;